import { __decorate, __extends, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
import { EntityContextService } from './entity-context.service';
var ProductContextService = (function (_super) {
    __extends(ProductContextService, _super);
    function ProductContextService($q) {
        return _super.call(this, $q) || this;
    }
    ProductContextService.$inject = ['$q'];
    ProductContextService = __decorate([
        Injectable('productContextService'),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], ProductContextService);
    return ProductContextService;
}(EntityContextService));
export { ProductContextService };
